const WORDS = ["SECURE", "CONNECT", "AUTOMATE"];

export default function EditorialMarquee() {
  return (
    <div
      className="marquee-paused overflow-hidden border-y border-slate-800/70 bg-[#0B0F19] py-10"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="marquee marquee-slow items-center gap-0">
        {[...Array(4)].flatMap((_, r) =>
          WORDS.map((w, i) => (
            <span key={`${r}-${i}`} className="flex shrink-0 items-center">
              <span
                className={`font-heading text-6xl font-extrabold tracking-tight sm:text-7xl lg:text-8xl ${
                  i % 2 === 0 ? "text-stroke" : "text-white/90"
                }`}
              >
                {w}
              </span>
              <span className="mx-8 text-3xl text-brand sm:text-4xl">·</span>
            </span>
          ))
        )}
      </div>
    </div>
  );
}
